<template>
  <div>
    <toggle-collapse>
      <DevicesListFilters :haseSupportFilter="true" @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
    </toggle-collapse>
    <!-- form report -->
    <b-card style="position: relative">

      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">

          <!-- devices  -->
          <b-col cols="4">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- geofence  -->


          <b-col md="8" sm="8">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col cols="12">


            <b-row>


              <b-col cols="4">


                <div class="demo-inline-spacing">

                  <b-form-checkbox v-model="request.dependsOn" value="duration">
                    {{ $t('depends on duration') }}
                  </b-form-checkbox>


                  <small v-if="errors && ('dependsOn' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn'][0]) }}
                  </small>

                </div>

              </b-col>
              <b-col cols="4">
              
                <b-form-group :label="$t('duration operator')" label-for="vi-devices-id">
                  <v-select v-model="request.dependsOn_duration_operator"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                    
                    :getOptionLabel="d =>d.name"
                    :options="searchoperations.map(i=>({id:i.id,name:$t(i.name)}))" :reduce="d => d.id" />
                  <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                    {{ $t(errors['dependsOn_duration_operator'][0]) }}
                  </small>
                </b-form-group>
              </b-col>


              <b-col cols="4">
                <b-form-group :label="$t('duration Hr')" label-for="dependsOn_duration">
                  <cleave id="dependsOn_duration" v-model="request.dependsOn_duration" class="form-control" :raw="false"
                    :options="{
                      numeral: true,
                      numeralThousandsGroupStyle: 'thousand',
                    }" placeholder="00:00" />
                </b-form-group>
              </b-col>

            </b-row>
          </b-col>
 
          <b-col cols="4">
            <b-form-group :label="$t('area category')" label-for="vi-devices-id">
              <v-select v-model="request.geofences"
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                 :getOptionLabel="d => d.name" :options="inside.map(i=>({id:i.id,name:$t(i.name)}))"
                :reduce="d => d.id" />
              <small v-if="errors && ('dependsOn_duration_operator' in errors)" class="text-danger">
                {{ $t(errors['dependsOn_duration_operator'][0]) }}
              </small>
            </b-form-group>
          </b-col>


        </b-row>
        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <DataTable :report_data="report_data" :report_fields="report_fields"
      :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
      :getReport="getReport" :total="total" :from="from" :to="to" :sortData="sortData" />

  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'
import reportForm from '@/app/reports/compactor/reportForm'
import CompactorReportLogic from '@/app/reports/compactor/logic'
import { ExportDataServices } from '@/share/reports/exportService'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'

import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'

import ReportOptions from '@/views/reports/components/options.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'

export default {
  name: 'CompactorReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    DevicesListFilters,
    ToggleCollapse,
    DataTable
  },
  directives: { Ripple, },

  setup(props, { root }) {
    const { devices } = FilterLogic()


    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }
      Object.assign(request.value, data);
    }

    const rangeDate = ref('')
    const tableRef = ref(null)
    
    const { geofences, inside, searchoperations } = reportForm()

    const { report_data, request, errors, loading, getReport, total, from, to,isSortDirDesc,sortBy ,dataTableloading} = CompactorReportLogic()

    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const perPageOptions = [5, 10, 25, 50, 100]
    const { pickerOptions } = ReportOptions(request.value)


    const report_wrapper = ref(null)

    const filter_included_fields = ['device', 'weekday', 'duration_string', 'start_dump', 'location', 'geofence','owner','contract'];
    const report_fields = [
      {
        key: 'index',
        label: 'id',
        
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label: 'contract',
        sortable: true
      },
      {
        key: 'device',
        label: 'device',
        sortable: true
      },
      {
        key: 'weekday',
        label: 'day_weak',
        sortable: true
      },
      {
        key: 'duration_string',
        label: 'rainReport.durationTime',
        sortable: true
      },
      {
        key: 'start_dump',
        label: 'start dump',
        sortable: false
      },
      {
        key: 'location',
        label: 'location',
        sortable: false
      },
      {
        key: 'geofence',
        label: 'compactor.geofence',
        sortable: false
      },
     



    ]






    const isNamePresent = computed(() => { });
    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,

      devices,
      geofences,
      inside,

      pickerOptions,
      report_wrapper,


      request,
      loading,
      errors,
      isNamePresent,
      searchoperations,
      divicesFilterd,
      merageFilterWithRequest,
      sortData,
      dataTableloading
    }


  },



}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
